import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useReveal } from "../hooks/useReveal";
import { ItalyFlag } from "./ItalyFlag";

export const Stats = () => {
  const { t } = useI18n();
  const { ref, visible } = useReveal();

  const items = [
    { v: "70+", k: t.stats.years },
    { v: "12", k: t.stats.categories },
    { v: "100%", k: t.stats.madeIn, flag: true },
  ];

  return (
    <section
      ref={ref}
      data-testid="stats-section"
      className={`reveal ${visible ? "visible" : ""} bg-[#1a3a2a] text-white relative grain overflow-hidden`}
    >
      <div className="pb-container py-14 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-y-10 gap-x-6 relative">
        {items.map((it, i) => (
          <div
            key={i}
            data-testid={`stat-item-${i}`}
            className={`flex flex-col items-start ${
              i !== 0 ? "md:border-l md:border-white/15 md:pl-8" : ""
            }`}
          >
            <span className="font-heading font-bold text-4xl md:text-5xl text-[#c9a84c] tracking-tight">
              {it.v}
            </span>
            <span className="mt-2 inline-flex items-center gap-2 text-xs md:text-sm uppercase tracking-[0.2em] text-white/70">
              {it.k}
              {it.flag && <ItalyFlag width={16} />}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
